/** This export is automatically generated. */
export const salesFlow = {
  activeCampaign: 'Aktiv rabattkode',
  addCampaignCode: 'Legg til',
  availableCampaignCode: 'Tilgjengelig kampanjekode',
  buyNow: 'Kjøp nå',
  campaignCodeIdentifierLabel: 'Kode: $code$',
  campaignLabel: 'Kampanje',
  campaignPaymentDetailNoBinding:
    'etter $campaignEndDate$. $campaignPrice$ kr i kampanjeperioden',
  campaignPaymentDetailBinding:
    '$monthsBinding$ måneders bindingstid starter fra $campaignEndDate$',
  centerLabel: 'Senter',
  createSessionDecodeError: 'Oops! Noe gikk galt da vi prøvde å lese dataene',
  createSessionNoSubscriptionsCache:
    'Vi fant ingen tilgjengelige medlemskap akkurat nå.',
  createSessionNoSubscriptionsExerp:
    'Vi fant ingen tilgjengelige medlemskap akkurat nå.',
  createSessionTimeout:
    'Det tok litt for lang tid å opprette en økt. Oppdater siden og prøv igjen.',
  createSessionUnknown:
    'Noe uventet skjedde. Vi ser på saken – prøv igjen senere.',
  details: 'Detaljer',
  discountCode: 'Rabattkode',
  discountCodeInvalidTemplate: 'Koden $code$ er ikke gyldig',
  discountCodeRemove: 'Fjern',
  discountPriceExpiryTemplate: 'Prisen justeres til ordinær pris etter $end$',
  discountPriceLabel: 'Kampanjepris',
  discountDisclaimer: 'Det kan kun benyttes en rabattkode om gangen.',
  discountLabel: 'Legg til rabattkode',
  createCheckoutSessionDecodeError: 'Hmm, noe gikk litt skeis med dataene.',
  createCheckoutSessionDownstreamError: 'DownstreamError',
  createCheckoutSessionExpiredSession:
    'Salgsøkten har dessverre utløpt så du må begynne på ny',
  createCheckoutSessionUnknown:
    'Noe uventet skjedde. Vi ser på saken – prøv igjen senere.',
  createCheckoutSessionValidationError:
    'Oops! Noe gikk galt da vi prøvde å lese dataene.',
  getSessionDecodeError: 'Oops! Noe gikk galt da vi prøvde å lese dataene.',
  getSessionExpiredSession:
    'Salgsøkten har dessverre utløpt så du må begynne på ny',
  getSessionTimeout: 'Salgsøkten har dessverre utløpt så du må begynne på ny',
  getSessionUnknown:
    'Noe uventet skjedde. Vi ser på saken – prøv igjen senere.',
  invalidCampaignCode: 'Koden er ikke gyldig',
  membershipSelectionsTitle: 'Medlemskap',
  membershipTypeLabel: 'Type',
  missingSessionCookie: 'Missing session cookie',
  paymentCardTitle: 'Betalingskort',
  paymentCompleteAuthenticationFinished: 'AuthenticationFinished',
  paymentCompleteAuthenticationNotRequired: 'AuthenticationNotRequired',
  paymentCompleteAuthorised: 'Authorised',
  paymentCompleteCancelled: 'Cancelled',
  paymentCompleteChallengeShopper: 'ChallengeShopper',
  paymentCompleteError: 'Error',
  paymentCompleteIdentifyShopper: 'IdentifyShopper',
  paymentCompletePartiallyAuthorised: 'PartiallyAuthorised',
  paymentCompletePending: 'Pending',
  paymentCompletePresentToShopper: 'PresentToShopper',
  paymentCompleteReceived: 'Received',
  paymentCompleteRedirectShopper: 'RedirectShopper',
  paymentCompleteRefused: 'Refused',
  paymentErrorCheckout: 'Unknown error during payment',
  paymentErrorLoading: 'Unknown error loading the payment component',
  paymentNoscript: 'You must enable JavaScript to pay',
  paymentSelectionsTitle: 'Med eller uten binding',
  paymentSelectionsAgeDisclaimer:
    'Merk at bindingstid ikke kan kjøpes av personer under 18 år',
  paymentTypeLabel: 'Bindingstid',
  paymentQueryNotOk: 'Query not OK. Please go back and try again.',
  registrationBirthdayHelp: 'Du må ha fylt 15 år for å bli medlem',
  registrationFormTitle: 'Om deg',
  registrationInvalidMemberInformation: 'InvalidMemberInformation',
  registrationErrorInvalidEmail: 'E-postadressen er ikke gyldig. ',
  registrationErrorInvalidPhonenumber: 'Telefonnummer er ikke gyldig.',
  registrationErrorMemberTooYoung:
    'Du må være 18 år for å kunne kjøpe dette medlemskapet. ',
  registrationGenericError:
    'Oisann! Noe gikk galt med registreringen av din informasjon, ta kontakt med kundeservice for hjelp. ',
  selectClubTitle: 'Velg senter ',
  selectMembershipErrorCacheMiss:
    'Missing cache. Please go back and try again.',
  selectMembershipErrorGeneric:
    'Noe uventet skjedde. Vi ser på saken – prøv igjen senere.',
  selectMembershipQueryNotOk: 'Missing club. Please go back and choose a club.',
  stale:
    'You have already paid or tried to pay. Choose a club to buy another membership.',
  startDateLabel: 'Startdato',
  stepTitle: 'Bli medlem',
  updateSessionDecodeError: 'Oops! Noe gikk galt da vi prøvde å lese dataene',
  updateSessionExpiredSession:
    'Salgsøkten har dessverre utløpt så du må begynne på ny',
  updateSessionNoSubscriptionsExerp:
    'Vi fant ingen tilgjengelige medlemskap akkurat nå.',
  updateSessionNoSubscriptionsCache:
    'Vi fant ingen tilgjengelige medlemskap akkurat nå.',
  updateSessionTimeout:
    'Salgsøkten har dessverre utløpt så du må begynne på ny',
  updateSessionUnknown:
    'Noe uventet skjedde. Vi ser på saken – prøv igjen senere.',
  loading: 'Vennligst vent',
  confirmationHome: 'Tilbake til forsiden',
  confirmationPaidTodayTemplate: '$price$ betalt i dag',
  confirmationPriceAfterCampaignTemplate: 'Deretter $price$',
  confirmationReceipt: 'Kvittering er sendt til e-posten din',
  confirmationTitle: 'Medlemskapet er klart',
  confirmationWelcome: 'Velkommen til Fresh Fitness.',
  campaignEndDate: 'ut $date$',
  subscriptionCampaignPrice: '$price$ kr til $date$',
  downloadAppButton: 'Last ned app',
  subscriptionPriceAfterCampaign: 'Deretter $price$',
  subscriptionOriginalPrice: 'Orginalt $price',
  membershipInformationAgeRestrictionBinding:
    'Under 18 år? Velg uten binding – bindingstid er kun tilgjengelig fra fylte 18 år.',
  membershipInformationNoticePeriod:
    'Alminnelig oppsigelsestid gjelder ved medlemskap uten binding.',
  allClubs: 'Alle sentre',
  clubSizeTemplate: '$size$ kvm',
  clubCount: '$clubCount$ sentre',
  stepProgressTemplate: 'Steg $currentStep$ av $totalSteps$',
  aboutYou: 'Om deg',
  selectClub: 'Bli medlem',
  selectMembership: 'Medlemskap',
  selectPaymentMethod: 'Velg betalingsmetode',
  membershipDiscountQuestion: 'Har du en rabattkode?',
  campaignCountdownPrefix: 'SLUTTER OM',
  payment: 'Betaling',
  paymentSummaryCampaignDisclaimer: 'etter kampanjen',
  paymentSummaryCollapseLabel: 'Skjul betalingsoversikt',
  paymentSummaryExpandLabel: 'Vis betalingsoversikt',
  paymentSummaryPayTodayLabel: 'Å betale nå',
  openingHoursTemplate: 'Åpent $from$–$to$',
  regionFilterLabel: 'Filtrer etter region',
  regionFilterAllClubs: 'Alle',
  locationSearchPlaceholder: 'Søk med postnummer',
  locationSearchButton: 'Søk',
  nearestMeLabel: 'Finn sentre nær meg',
  nearestResultsTemplate: 'Nærmest $location$',
  nearestYou: 'deg',
  basedOnPosition: 'Basert på posisjonen din',
  noClubsWithinRange: 'Det finnes ingen sentre i nærheten av ditt søk',
  yourInformation: 'Dine opplysninger',
} as const;
